import { render, staticRenderFns } from "./IonForm.vue?vue&type=template&id=18bc1592"
import script from "./IonForm.vue?vue&type=script&lang=js"
export * from "./IonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports